(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meine-neue-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  //jshint esversion:6
console.log('Bootstrap Slider läuft');

const carliItems = document.querySelectorAll('.carousel-inner div');
let currentIndex = 0;

function showFirstLi() {
  carliItems[currentIndex].classList.add('active');
  console.log(carliItems[currentIndex]);
}

function showNextLi() {
  carliItems[currentIndex].classList.remove('active');

  // Überprüfen, ob das letzte Element erreicht ist
  if (carliItems.length - 1 == currentIndex) {
    currentIndex = 0;
  } else {
    currentIndex = currentIndex + 1;
  }

  carliItems[currentIndex].classList.add('active');
  console.log(carliItems[currentIndex]);
}

showFirstLi();
setInterval(showNextLi, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-age-gate"]) return;
  try {
    
  (() => {
    const storageKey = 'messgrow_age_verified_v1';
    const cookieKey = 'messgrow_age_verified';
    const gate = document.querySelector('[data-mg-age-gate]');

    if (!gate || gate.dataset.designMode === 'true') return;

    const panel = gate.querySelector('.mg-age-gate__panel');
    const question = gate.querySelector('[data-mg-age-question]');
    const denied = gate.querySelector('[data-mg-age-denied]');
    const confirmButton = gate.querySelector('[data-mg-age-confirm]');
    const declineButton = gate.querySelector('[data-mg-age-decline]');
    const leaveButton = gate.querySelector('[data-mg-age-leave]');
    const rememberDays = Math.max(1, Number(gate.dataset.rememberDays) || 30);
    const sectionRoot = gate.closest('.shopify-section');
    const lockedElements = [];

    const readStoredExpiry = () => {
      try {
        const stored = Number(localStorage.getItem(storageKey));
        if (stored > Date.now()) return stored;
      } catch (error) {
      }

      const cookie = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith(`${cookieKey}=`));
      return cookie ? Number(cookie.split('=')[1]) : 0;
    };

    const lockPage = () => {
      document.documentElement.classList.add('mg-age-gate-open');
      Array.from(document.body.children).forEach((element) => {
        if (element === sectionRoot) return;
        lockedElements.push({
          element,
          inert: element.inert,
          ariaHidden: element.getAttribute('aria-hidden')
        });
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
      });
    };

    const unlockPage = () => {
      document.documentElement.classList.remove('mg-age-gate-open');
      lockedElements.forEach(({ element, inert, ariaHidden }) => {
        element.inert = inert;
        if (ariaHidden === null) {
          element.removeAttribute('aria-hidden');
        } else {
          element.setAttribute('aria-hidden', ariaHidden);
        }
      });
    };

    const closeGate = () => {
      gate.hidden = true;
      unlockPage();
    };

    if (readStoredExpiry() > Date.now()) return;

    gate.hidden = false;
    lockPage();
    requestAnimationFrame(() => confirmButton.focus());

    confirmButton.addEventListener('click', () => {
      const expires = Date.now() + rememberDays * 86400000;
      try {
        localStorage.setItem(storageKey, String(expires));
      } catch (error) {
      }
      document.cookie = `${cookieKey}=${expires}; max-age=${rememberDays * 86400}; path=/; SameSite=Lax`;
      closeGate();
    });

    declineButton.addEventListener('click', () => {
      question.hidden = true;
      denied.hidden = false;
      leaveButton.focus();
    });

    leaveButton.addEventListener('click', () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.replace('about:blank');
      }
    });

    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('button:not([hidden])'))
        .filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
